import { useMemo } from 'react';
import { usePathname, useRouter, useSearchParams } from 'next/navigation';

import { Select } from '@components/common';

import { SORT_METHODS_PRODUCTS } from './constants';

export const SortProducts = () => {
  const router = useRouter();
  const pathname = usePathname();
  const urlSearchParams = useSearchParams();
  const searchParams = Object.fromEntries(urlSearchParams.entries());

  const sortAttribute =
    searchParams.sortAttribute || SORT_METHODS_PRODUCTS[0].value.attribute;
  const sortDirection =
    searchParams.sortDirection || SORT_METHODS_PRODUCTS[0].value.sortDirection;

  const value = useMemo(() => {
    return SORT_METHODS_PRODUCTS.find(
      sort =>
        sort.value.attribute === sortAttribute &&
        sort.value.sortDirection === sortDirection
    );
  }, [sortAttribute, sortDirection]);

  return (
    <div>
      <Select
        options={SORT_METHODS_PRODUCTS}
        name="sort"
        defaultValue={value}
        onChange={({ value }: (typeof SORT_METHODS_PRODUCTS)[0]) => {
          const nextURLParams = new URLSearchParams(urlSearchParams.toString());

          nextURLParams.set('sortDirection', value.sortDirection);

          nextURLParams.set('sortAttribute', value.attribute);

          router.push(`${pathname}?${nextURLParams.toString()}`);
        }}
      />
    </div>
  );
};
